import { inspectionTargetApi } from "apiClient/v2";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { logDev } from "utils/logs";
import {
  useContextInspectionDetail,
  useInspectionDetailDispatch,
} from "../context/inspectionDetail";
import { DETAIL_MODE, Types } from "../context/inspectionDetailReducer";

const useFetchTargetObjects = () => {
  const dispatchContext = useInspectionDetailDispatch();
  const { targetObjects, mode } = useContextInspectionDetail();

  const { id: inspectionTypeId } = useParams();

  useEffect(() => {
    if (
      !inspectionTypeId ||
      targetObjects?.length ||
      mode === DETAIL_MODE.ALL ||
      mode === DETAIL_MODE.ADD_DOCUMENT ||
      mode === DETAIL_MODE.EDIT_DOCUMENT
    ) {
      return;
    }

    (async () => {
      try {
        dispatchContext({
          type: Types.SET_LOADING_HIGHLIGHT_OBJECTS,
          payload: true,
        });

        const [objectsResult] = await Promise.all([
          inspectionTargetApi.getCombinedObjectList(inspectionTypeId),
        ]);

        dispatchContext({
          type: Types.SET_TARGET_OBJECTS,
          payload: objectsResult?.data || [],
        });
      } catch (error) {
        logDev(error);
      } finally {
        dispatchContext({
          type: Types.SET_LOADING_HIGHLIGHT_OBJECTS,
          payload: false,
        });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inspectionTypeId, targetObjects?.length, mode]);

  return {};
};

export default useFetchTargetObjects;
